import { useState } from "react";
import { Link } from "react-router-dom";
import { isNative, PUBLIC_HOME } from "@/lib/native";
import { useAuth } from "@/context/AuthContext";
import CelestialBackground from "@/components/CelestialBackground";
import BottomNav, { PublicNav } from "@/components/BottomNav";
import PreviewSheet from "@/components/PreviewSheet";
import SiteMenu from "@/components/SiteMenu";

export const WIDE = !isNative;

export default function PublicShell({ children, testId }) {
  const { user } = useAuth();
  const [locked, setLocked] = useState(null);
  const desk = WIDE ? "lg:hidden" : "";
  return (
    <div className={`app-shell relative text-starlight ${WIDE ? "wide-desktop" : ""}`}>
      <CelestialBackground />
      <div className={`relative z-10 ${WIDE ? "pb-40 lg:pb-16" : "pb-28"}`} data-testid={testId}>
        <header className={`relative z-20 safe-top box-content h-16 px-5 flex items-center gap-1 ${WIDE ? "lg:h-20 lg:px-10 lg:max-w-6xl lg:mx-auto" : ""}`}>
          <SiteMenu />
          <Link to={PUBLIC_HOME} data-testid="public-shell-home" className="flex items-center gap-1">
            <img src="/astra-mark-128.png" alt="" aria-hidden="true" className="w-9 h-9 -mr-0.5" />
            <span className="font-display text-lg tracking-[0.3em]">ASTRA</span>
          </Link>
          {WIDE && (
            <nav className="hidden lg:flex items-center gap-8 ml-14 text-base text-[#D6D0C5]">
              <Link to="/" data-testid="shell-nav-horoscopes" className="hover:text-starlight transition-colors">Horoscopes</Link>
              <Link to="/readings" data-testid="shell-nav-readings" className="hover:text-starlight transition-colors">Readings</Link>
              <Link to={user ? "/ask" : "/try"} data-testid="shell-nav-interactive" className="hover:text-starlight transition-colors">Astra Interactive</Link>
            </nav>
          )}
          {user ? (
            <Link to="/today" data-testid="shell-my-astra" className="ml-auto text-sm lg:text-base gold-text py-2.5 px-1">My Astra</Link>
          ) : (
            <Link to="/join?mode=login" data-testid="shell-signin" className="ml-auto text-sm lg:text-base gold-text py-2.5 px-1 lg:px-3">Sign in</Link>
          )}
        </header>
        {children}
      </div>
      {user ? <BottomNav className={desk} /> : <PublicNav onLocked={setLocked} className={desk} />}
      <PreviewSheet label={locked} onClose={() => setLocked(null)} />
    </div>
  );
}
